// Platform data used across the application
// This centralized file allows for easier maintenance of platform lists

/**
 * Platform groups with their options for use in dropdown selects
 */
export const platformGroups = [
    {
    label: "Platforms",
    options: [
        { value: "Select Platform", label: "Select Platform" }
    ]
    },
  {
    label: "CMS",
    options: [
      { value: "WordPress", label: "WordPress" }
    ]
  },
  {
    label: "E-commerce",
    options: [
      { value: "Shopify", label: "Shopify" },
      { value: "WooCommerce", label: "WooCommerce" },
    ]
  },
  {
    label: "Website Builders",
    options: [
      { value: "Wix", label: "Wix" },
      { value: "Squarespace", label: "Squarespace" },
      { value: "Webflow", label: "Webflow" },
      { value: "Weebly", label: "Weebly" },
      { value: "Elementor", label: "Elementor" },
      { value: "Divi", label: "Divi (by Elegant Themes)" },
      { value: "GoDaddy Website Builder", label: "GoDaddy Website Builder" },
    ]
  },
  {
    label: "Headless & JAMstack",
    options: [
      { value: "Next.js", label: "Next.js" }
    ]
  },
  {
    label: "Other",
    options: [
      { value: "Custom", label: "Custom Development" },
      { value: "PHP", label: "PHP" },
      { value: "React", label: "React" },
      { value: "Other", label: "Other" }
    ]
  }
];

/**
 * Flat list of all platform options (for searching or filtering)
 */
export const allPlatforms = platformGroups.reduce((acc, group) => {
  acc.push(...group.options);
  return acc;
}, []);

/**
 * Helper function to render platform options in select elements
 * @returns {Array} JSX elements for option groups and options
 */
export const renderPlatformOptions = () => {
  return platformGroups.map(group => (
    <optgroup label={group.label} key={group.label}>
      {group.options.map(option => (
        <option value={option.value} key={option.value}>{option.label}</option>
      ))}
    </optgroup>
  ));
};

/**
 * Get platform details by value
 * @param {string} value - Platform value to look up
 * @returns {Object|null} Platform object or null if not found
 */
export const getPlatformByValue = (value) => {
  for (const group of platformGroups) {
    const found = group.options.find(option => option.value === value);
    if (found) return found;
  }
  return null;
};

const platformsExport = {
  platformGroups,
  allPlatforms,
  renderPlatformOptions,
  getPlatformByValue
};

export default platformsExport;